<template>
	<div class="statsWrapper">
		<div class="allStats">
			<template v-if="statsArr.length === 0">
				Статистики пока нет.
			</template>
			
			<template v-if="statsArr.length > 0">
				<br>
				<table class="statsTable">
					<colgroup>
						<col>
						<col>
					</colgroup>
					<tr>
						<th>Дата</th><th>Процент правильных ответов</th>
					</tr>
					<tr v-for="(oneStat, index) in statsArr" :key="index">
						<td>{{ dateFromMs(oneStat.date) }}</td>
						<td>{{ 100 * (oneStat.correctAnswers / oneStat.questions)  + '%' }}</td>
					</tr>
				</table>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		dateFromMs(ms) {
			const date = new Date(ms);
			const year = date.getFullYear();
			const month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'][date.getMonth()];
			const day = date.getDay();
			let hours = date.getHours();
			if (String(hours).length === 1) { hours = `0${hours}`; }
			let minutes = date.getMinutes();
			if (String(minutes).length === 1) { minutes = `0${minutes}`; }
			return `${day}.${month}.${year} ${hours}:${minutes}`;
		},
	},
	
	mounted() {
		document.title = 'Статистика';
	},
	
	computed: {
		statsArr() {
			return JSON.parse(localStorage.getItem('frontendTestAllTimeStats')) || [];
		},
	},
};
</script>

<style scoped>
.statsWrapper {
	border: 0px solid #464646;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 10px; 
}

.allStats {
	border: 0px solid #464646;
	width: 100%;
	box-sizing: border-box;
	max-width: 800px;
}

.statsTable {
	border: 1px solid #606060;
	border-collapse: collapse;
}
.statsTable th, .statsTable td  {
	border: 1px solid #606060;
	padding: 0.4em;
	text-align: center;
}

</style>
